module.exports = __webpack_public_path__ + "img/app_logo_white_wide.a68988d7.jpg";